var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RESET_SUBMISSION, UPDATE_SUBMISSION } from "../../constants/common";
var submissionReducer = function (state, action) {
    switch (action.type) {
        case UPDATE_SUBMISSION:
            return { data: __assign(__assign({}, state.data), action.payload) };
        case RESET_SUBMISSION:
            return { data: {} };
        default:
            return state;
    }
};
export default submissionReducer;
//# sourceMappingURL=submission-reducer.js.map